import { Tag, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import type { DeviceConnectionType } from './attendanceApi'

/**
 * Server qurilmaga QANDAY YETADI — qurilmalar ro'yxatidagi ustun.
 *
 * <h2>⚠️ NEGA ALOHIDA USTUN KERAK BO'LDI</h2>
 * Rejimni faqat manzil ko'rinishidan taxmin qilish mumkin edi
 * (`10.0.0.5:80` yoki `AB1234567`), lekin bu taxmin: gateway
 * identifikatori ham raqamlardan iborat bo'lishi mumkin. Rejim esa
 * "nega ulanmayapti" degan savolning BIRINCHI ayrimchisi — VPN'siz
 * filialda tarmoqni tekshirishning ma'nosi yo'q, gateway'ni tekshirish
 * kerak. Uni taxminga qoldirish operatorni butunlay boshqa yo'nalishda
 * qidirishga yuborardi (`DeviceStatusTag` dagi `AUTH_FAILED` /
 * `UNREACHABLE` ajratmasi bilan bir xil sabab).
 *
 * ⚠️ `DIRECT_ISAPI` ham CHIZILADI, garchi u standart bo'lsa ham. Faqat
 * gateway qurilmalarini belgilash "belgisiz qator = eski yozuv" degan
 * ikkinchi o'qishga yo'l ochardi; bu yerda esa har qatorning rejimi
 * ATAYLAB qo'yilgan qiymat.
 *
 * ⚠️ Ranglar neytral: rejimning biri ikkinchisidan yaxshi emas. Yashil
 * yoki qizil qo'yish gateway rejimini "muammo" yoki "yangi va yaxshiroq"
 * qilib ko'rsatardi — ikkalasi ham yolg'on.
 */
const COLOR: Record<DeviceConnectionType, string> = {
  DIRECT_ISAPI: 'default',
  ISUP_GATEWAY: 'blue',
}

export function DeviceConnectionTag({
  connectionType,
  /** Tor joyda — faqat yorliq, izohsiz */
  compact = false,
}: {
  connectionType: DeviceConnectionType
  compact?: boolean
}) {
  const { t } = useTranslation()

  const tag = (
    <Tag color={COLOR[connectionType]}>{t(`attendance.connectionTypes.${connectionType}`)}</Tag>
  )
  if (compact) {
    return tag
  }
  return <Tooltip title={t(`attendance.connectionTypeHints.${connectionType}`)}>{tag}</Tooltip>
}
